import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.scss';
import 'modern-normalize/modern-normalize.css';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);
